import { Col } from "react-grid-system";
import styled from "styled-components";
import { theme } from "../theme";

export const StyledProfileDetailsData = styled.div`
	margin-top: 2.4rem;
	h2 {
		font-size: 1.4rem;
		font-family: ${theme.font.secondary};
		padding-bottom: 0.6rem;
		border-bottom: 0.1rem solid ${theme.color.black};
		margin-bottom: 1.8rem;
		text-transform: uppercase;
	}
`;

export const StyledProfileDetailsDataButtons = styled(Col)`
	display: flex;
	column-gap: 2.4rem;
	row-gap: 1.6rem;
	margin-top: 1.4rem;
`;
